import React, { useEffect, useRef, useState } from "react";
import { pageClass, pageHeader } from "../Components/Utils/CustomClasses";
import Table from "../Components/Table/Table";
import { useLocation, useNavigate } from "react-router-dom";
import { GetLeadsByGroupsAPI } from "../API/Api";
import usePaginatedData from "../Components/Utils/UsePagination";
import { useThemeColor } from "../Components/Sidebar/SideBarApi";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { IconArrowNarrowLeft, IconChevronLeft, IconChevronRight, IconEye } from "@tabler/icons-react";

export default function ViewGroupDetails() {
  const location = useLocation();
  const themeColor = useThemeColor(); 
  const UserDetails = useSelector((state) => state?.login?.userDetails); 
  const navigate = useNavigate();
  const { register } = useForm(); 
  const { rowdata } = location.state || {};
  

  const initialFilterState = {
    p: 1,
    viewGroupsid: rowdata?._id,
  };
  const [filterObject, setFilterObject] = useState({ ...initialFilterState });
  const filterTimeout = useRef();
  const {
    filterData: viewGroups,
    pageNo,
    nextIsValid,
    prevIsValid,
    pageChangeHandler,
    recordChangeHandler,
    fetchData,
  } = usePaginatedData(1, 50, GetLeadsByGroupsAPI, filterObject);


  const tableColumns = [
    {
      field: "First_Name",
      header: "First Name",
      style: true,
      body: (row) => <h6>{row?.firstName || "-----"}</h6>,
    },
    {
      field: "Last_Name",
      header: "Last Name",
      style: true,
      body: (row) => <h6>{row?.lastName || "-----"}</h6>,
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => <h6>{row?.email || "-----"}</h6>,
    },
    {
      field: "phone_number",
      header: "Phone Number",
      style: true,
      body: (row) => <h6>{row?.phoneNumber || "-----"}</h6>,
    },
    {
      field: "Lead_source",
      header: "Lead Source",
      style: true,
      body: (row) => <h6>{row?.leadSource || "-----"}</h6>,
    },
    {
      field: "assigned_to",
      header: "Assigned To",
      style: true,
      body: (row) => (
        <h6>
          {row?.assigned_to?.first_name}{" "}
          {row?.assigned_to?.last_name || "-----"}
        </h6>
      ),
    },
    {
      field: "Actions",
      header: "Actions",
      style: true,
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            onClick={(e) => {
              e.preventDefault();
              handleNavigate(row);
            }}
            className="py-1 rounded-lg flex justify-center w-1/2"
          >
            <IconEye stroke={1.5} size={24} color="#000" />
          </button>
        </div>
      ),
    },
  ];

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };
  
  const handleNavigateViewGroup = (row) => {
    navigate(-1);
  };

  const handleNavigate = (row) => {
    navigate("/teamleads-detail", { state: { leadData: row } });
  };

  useEffect(() => {
    filterRecords();
  }, [filterObject]);

  useEffect(() => {
    setFilterObject({
      ...initialFilterState,
      id: UserDetails?._id || "",
      role: UserDetails?.role?.roleName || "",
    });
  }, [UserDetails]);

  return (
    <>
      <div className={`${pageClass}`}>
        <div className="ml-[21px] cursor-pointer">
          <button
            onClick={(e) => {
              e.preventDefault();
              handleNavigateViewGroup();
            }}
          >
            <IconArrowNarrowLeft stroke={1.5} size={50} color={themeColor} variant="Bold" />
          </button>
        </div>
        <div className="bg-[#FFFFFF] p-4 m-4 my-2 sm:my-5 min-w-[262px] sm:mt-0 sm:m-5 rounded-xl">
          <h1 className={`${pageHeader} pb-4 text-[27px] sm:text-[32px]`}>
            Group Details
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <div className="p-2 sm:p-4 rounded-xl">
              <label className="capitalize font-bold text-slate-600">
                Group Names
              </label>
              <div>
                <p className="capitalize text-slate-600">
                  {`${
                    rowdata?.grpName !== undefined ? rowdata?.grpName : "N/A"
                  }`}
                </p>
              </div>
            </div>
            <div className="p-2 sm:p-4 rounded-xl">
              <label className="capitalize font-bold text-slate-600">
                Users
              </label>
              <div>
                <p className="capitalize text-slate-600">
                  {rowdata?.users && rowdata.users.length > 0
                    ? rowdata.users
                        .map(
                          (user) =>
                            `${user?.first_name || "-----"} ${
                              user?.last_name || "-----"
                            }`
                        )
                        .join(", ")
                    : "-----"}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="p-4 m-1 my-2 sm:my-5 min-w-[305px] sm:mt-0 sm:m-5">
          <div className="bg-[#FFFFFF] p-10 rounded-xl">
            <h1 className={`${pageHeader} pb-4 text-[27px] sm:text-[32px]`}>
              Group Leads
            </h1>
            <Table
              columns={tableColumns}
              data={viewGroups}
              paginatorCheck={true}
            />
            <div className="flex flex-row justify-end gap-4 mt-3 relative items-center">
              {prevIsValid && (
                <>
                  <span
                    onClick={() => {
                      pageChangeHandler(pageNo - 1);
                    }}
                  >
                    <IconChevronLeft stroke={1.5} size={23} color={themeColor} variant="Bold" />
                  </span>
                </>
              )}
              {nextIsValid && (
                <span
                  onClick={() => {
                    pageChangeHandler(pageNo + 1);
                  }}
                >
                  {" "}
                   <IconChevronRight stroke={1.5} size={23} color={themeColor} variant="Bold" />
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
